import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

function Team() {
  return (
    <>
      <Navbar />
        <div>Team</div>
      <Footer />
    </>

  )
}

export default Team